// src/api/apiClient.js
import axios from 'axios';
import { getOrgId } from '../utils/orgUtils';
import { toast } from 'react-toastify';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || 'http://localhost:8000', // or your NestJS URL
  // ...existing code...
});

// Add a request interceptor to attach token and orgId
apiClient.interceptors.request.use((config) => {
  const orgId = getOrgId();
  if (orgId) {
    config.headers['X-Organization-ID'] = orgId;
  }

  if (config.data && typeof config.data.org_id === 'string') {
    config.data.org_id = parseInt(config.data.org_id);
  }
  if (config.params && typeof config.params.org_id === 'string') {
    config.params.org_id = parseInt(config.params.org_id);
  }
  const token = localStorage.getItem('token');
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

// Add a response interceptor to catch 401
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    let errorMessage = 'An error occurred';

    if (error.response) {
      switch (error.response.status) {
        case 401:
          localStorage.removeItem('token');
          window.location.href = '/auth';
          return Promise.reject(error);
        case 404:
          errorMessage = error.response.data?.message || 'Resource not found';
          toast.error(errorMessage);
          break;
        case 409:
          errorMessage = error.response.data?.message || 'Operation failed due to a conflict';
          toast.error(errorMessage);
          break;
        default:
          // Don't show toast for 5xx errors
          if (error.response.status < 500) {
            errorMessage = error.response.data?.message || 'Operation failed';
            toast.error(errorMessage);
          }
      }
    } else if (error.request) {
      errorMessage = 'Network error. Please check your connection.';
      toast.error(errorMessage);
    }

    return Promise.reject(error);
  }
);

export default apiClient;
